import { useIsBot } from '@packages/tracking/src/hooks/useIsBot/useIsBot';
import { getCanonicalUrl } from '@packages/shared/src/utils/getCanonicalUrl/getCanonicalUrl';

/**
 * A hook that returns a function that determines the target URL based on the bot status.
 * If the user agent is a bot, the function returns the canonical URL, otherwise it returns the original URL.
 *
 * @returns {Function} A function that accepts a URL as an argument and returns the target URL based on the bot status.
 */
export const useAssignLinkTargetBasedOnBotStatus = (): Function => {
  const isBot = useIsBot();
  return (url: string): string => (isBot ? getCanonicalUrl(url) : url);
};
